<template>
  <el-dialog
    title="搜索屏蔽词管理"
    :visible="flag"
    width="800px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="handleClose"
  >
    <div class="box-add">
      <el-input
        class="add-input"
        v-model="content"
        placeholder="请输入您要添加的屏蔽词"
      />
      <el-button type="primary" @click="handleAdd">保存为屏蔽词</el-button>
    </div>
    <div>
      <el-tag
        class="words"
        v-for="tag in wordList"
        :key="tag.id"
        closable
        style="margin-top: 5px"
        @close="handleDel(tag)"
      >
        {{ tag.content }}
      </el-tag>
    </div>
  </el-dialog>
</template>
<script>
import * as API from '../../../api/api'
export default {
  name: 'BlockWord',
  data() {
    return {
      flag: false,
      content: '',
      wordList: []
    }
  },
  methods: {
    handleOpen() {
      this.flag = true
      this.getWordList()
    },
    async getWordList() {
      try {
        const res = await API.getWordList()
        const {
          code,
          data: { records = [] }
        } = res
        if (code === 0) {
          this.wordList = records
        }
      } catch (error) {}
    },
    async handleAdd() {
      const { content } = this
      if (!content) {
        this.$message.warning('请输入后添加')
        return
      }
      try {
        const data = { content }
        const res = await API.addWord(data)
        const { code } = res
        if (code === 0) {
          this.getWordList()
          this.content = ''
        }
      } catch (error) {}
    },
    async handleDel(row) {
      const { id } = row
      try {
        const data = { id }
        const res = await API.delWord(data)
        const { code } = res
        if (code === 0) {
          this.getWordList()
        }
      } catch (error) {}
    },
    handleClose() {
      this.flag = false
    }
  }
}
</script>
<style lang='scss' scoped>
.box-add {
  margin-bottom: 20px;
  .add-input {
    width: 200px;
    margin-right: 20px;
  }
}
.words {
  margin-right: 20px;
}
</style>